__turbopack_context__.v({
  "contentWrapper": "N0HttG_contentWrapper",
  "expandedContainer": "N0HttG_expandedContainer",
  "sidebarContainer": "N0HttG_sidebarContainer",
  "sidebarIcon": "N0HttG_sidebarIcon",
});
